import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { SmartSuspensePanelComponent } from './lib/smart-suspense-panel.component'
import { SmartSuspenseKey } from './panel-key'

export * from './lib/smart-suspense.module'
export * from './panel-key'

export const SmartSuspensePanelConfig: PanelConfig = {
  key: SmartSuspenseKey,
  title: 'Smart Suspense',
  description: 'Reporting and Annotation Tool For Suspense',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: SmartSuspensePanelComponent,
  accessPermission: 'accessSmartSuspensePanel',
  isExternal: true,
}
